import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

type DialogSize = 'mediumSize' | 'largeSize' | 'extraLargeSize';
type ButtonAlignment = 'justify-center' | 'justify-end';
@Component({
  selector: 'lib-cdw-dialog',
  templateUrl: './cdw-dialog-content.component.html',
  styleUrls: ['./cdw-dialog-content.component.scss'],
  standalone: false,
})
export class CdwDialogContentComponent implements OnInit {
  @Output() primaryButtonClick = new EventEmitter<void>();

  @Output() secondaryButtonClick = new EventEmitter<void>();

  @Output() dismissButtonClick = new EventEmitter<void>();

  @Input() toolbarTitle = '';

  @Input() dialogSize: DialogSize = 'mediumSize';

  @Input() customWidth?: string;

  @Input() customHeight?: string;

  @Input() primaryButtonText?: string;

  @Input() secondaryButtonText?: string;

  @Input() primaryButtonDisabled = false;

  @Input() secondaryButtonDisabled = false;

  @Input() buttonAlignment?: ButtonAlignment;

  @Input() hard?: boolean = false;

  public ngOnInit(): void {
    if (!this.buttonAlignment && this.secondaryButtonText) {
      this.buttonAlignment = 'justify-end';
    }
    if (!(this.buttonAlignment || this.secondaryButtonText)) {
      this.buttonAlignment = 'justify-center';
    }
  }

  public buttonClick(target: 'primary' | 'secondary' | 'dismiss'): void {
    switch (target) {
      case 'primary':
        this.primaryButtonClick.emit();
        break;
      case 'secondary':
        this.secondaryButtonClick.emit();
        break;
      case 'dismiss':
        this.dismissButtonClick.emit();
        break;
      default:
        break;
    }
  }
}
